exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SearchResult__text___3l3e4 {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden; }\n\n.SearchResult__title___39NRl {\n  display: inline;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #000000; }\n\n.SearchResult__pale___2hdi- {\n  opacity: 50%; }\n\n.SearchResult__text___3l3e4 {\n  display: inline-block;\n  max-width: 250px; }\n  @media screen and (max-width: 576px) {\n    .SearchResult__text___3l3e4 {\n      max-width: 138px; } }\n\n.SearchResult__count____r5pG {\n  font-weight: 400;\n  margin: 0 5px 0 0; }\n", ""]);

// exports
exports.locals = {
	"text": "SearchResult__text___3l3e4",
	"title": "SearchResult__title___39NRl",
	"pale": "SearchResult__pale___2hdi-",
	"count": "SearchResult__count____r5pG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/SearchPage/SearchResult/SearchResult.scss
// module id = 4280
// module chunks = 6